<template>
    <v-container grid-list-md text-center>
        <v-layout wrap>
            <v-flex xs12>
                <v-card color="grey lighten-5" class="mb-10" height="auto">
                    <v-card-title>
                        <h5>Optimiseurs :</h5>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="$store.state.searchOptimizersList"
                            append-icon="mdi-magnify"
                            label="Recherche"
                            single-line
                            hide-details>
                        </v-text-field>															
                    </v-card-title>
                    <v-data-table
                        :headers="$store.state.OptimizersHeaders"
                        :items="$store.state.optimizersListBool"
                        :items-per-page="15"
                        :single-select="true"
                        :search="$store.state.searchOptimizersList"
                        :dense = true
                        item-key="ID"
                        class="elevation-1"
                    >
                        <template v-slot:top>
                            <v-toolbar
                                flat
                            >
                                <v-spacer></v-spacer>
                                <v-dialog
                                    v-model="dialogEdit"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        color="primary"
                                        dark
                                        class="mb-1"
                                        v-bind="attrs"
                                        v-on="on"
                                    >
                                        +
                                    </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">{{ formTitle }}</span>
                                        </v-card-title>
                                        <FormulaireOptimiseurs></FormulaireOptimiseurs>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeEdit"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="$store.state.optimizersEditedItem.REFERENCE != '' && 
                                                         $store.state.optimizersEditedItem.MANUFACTURER != '' && 
                                                         $store.state.optimizersEditedItem.INSTALLATION != '' && 
                                                         $store.state.optimizersEditedItem.POWER > 0" 
                                                         color="blue darken-1"
                                                text
                                                @click="saveEdit"
                                            >
                                                Enregistrer
                                            </v-btn>
                                        </v-card-actions>
                                        </v-card>
                                </v-dialog>
                                <v-dialog
                                    v-model="dialogCopy"
                                    max-width="1200px"
                                >
                                    <template v-slot:activator="{ on, attrs }">
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="text-h5">Copier l'optimiseur</span>
                                        </v-card-title>
                                        <FormulaireOptimiseurs></FormulaireOptimiseurs>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="blue darken-1"
                                                text
                                                @click="closeCopy"
                                            >
                                                Annuler
                                            </v-btn>
                                            <v-btn v-if="$store.state.optimizersEditedItem.REFERENCE != '' && 
                                                         $store.state.optimizersEditedItem.MANUFACTURER != '' && 
                                                         $store.state.optimizersEditedItem.INSTALLATION != '' && 
                                                         $store.state.optimizersEditedItem.POWER > 0" 
                                                         color="blue darken-1"
                                                text
                                                @click="saveCopy"
                                            >
                                                Ajouter
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="text-h5">Voulez-vous supprimer cet optimiseur ?</v-card-title>
                                        <v-card-text>
                                            {{ $store.state.optimizersEditedItem.REFERENCE }} {{ $store.state.optimizersEditedItem.DESC_FR }}
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Annuler</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon
                                small
                                class="mr-2"
                                @click="copyItem(item)"
                            >
                                mdi-content-copy
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="editItem(item)"
                            >
                                mdi-pencil
                            </v-icon>
                            <v-icon
                                small
                                class="mr-2"
                                @click="deleteItem(item)"
                            >
                                mdi-delete
                            </v-icon>
                        </template>
                        <template v-slot:item.OPTIMIZATION="{ item }">
                            <v-simple-checkbox
                                v-model="item.OPTIMIZATION"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.SAFETY="{ item }">
                            <v-simple-checkbox
                                v-model="item.SAFETY"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.MONITORING="{ item }">
                            <v-simple-checkbox
                                v-model="item.MONITORING"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.GATEWAY="{ item }">
                            <v-simple-checkbox
                                v-model="item.GATEWAY"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                        <template v-slot:item.CLOUD_CONNECT="{ item }">
                            <v-simple-checkbox
                                v-model="item.CLOUD_CONNECT"
                                disabled
                            ></v-simple-checkbox>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
	import axios from 'axios';
    import createListBoolMixins from './mixins/createListBoolMixins.js';
    import FormulaireOptimiseurs from './FormulaireOptimiseurs.vue';
	
	export default {
    name: "GestionOptimiseurs",
    components: { FormulaireOptimiseurs },
    mixins: [
        createListBoolMixins,
    ],
    data: function () {
        return {
            dialogEdit: false,
            dialogCopy: false,
            dialogDelete: false,
            editedIndex: -1,
            errorMessages: "",
            formHasErrors: false,
            defaultItem: {
                REFERENCE: '',
                MANUFACTURER: '',
                POWER: '',
                SOG_TYPE: '',
                OPTIMIZATION: false,
                SAFETY: false,
                MONITORING: false,
                GATEWAY: false,
                CLOUD_CONNECT: false,
                INSTALLATION: '',
            },
        };
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nouvel optimiseur" : "Modifier l'optimiseur";
        },
    },
    watch: {
        dialogEdit(val) {
            val || this.closeEdit();
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    mounted() {
        this.createOptimizersListBool();
    },
    methods: {
        getColor(admin) {
            if (admin == 0)
                return "red";
            else
                return "green";
        },
        copyItem(item) {
            this.editedIndex = this.$store.state.optimizersListBool.indexOf(item);
            this.$store.state.optimizersEditedItem = Object.assign({}, item);
            this.dialogCopy = true;
        },
        editItem(item) {
            this.editedIndex = this.$store.state.optimizersListBool.indexOf(item);
            this.$store.state.optimizersEditedItem = Object.assign({}, item);
            this.dialogEdit = true;
        },
        deleteItem(item) {
            this.editedIndex = this.$store.state.optimizersListBool.indexOf(item);
            this.$store.state.optimizersEditedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },
        deleteItemConfirm() {
            this.$store.state.optimizersListBool.splice(this.editedIndex, 1);
            this.closeDelete();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/deleteOptimizer.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.optimizersEditedItem.ID;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.optimizersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.optimizersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadOptimizersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.optimizersList = response.data;
                        this.createOptimizersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        closeCopy() {
            this.dialogCopy = false;
            this.$nextTick(() => {
                this.$store.state.optimizersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeEdit() {
            this.dialogEdit = false;
            this.$nextTick(() => {
                this.$store.state.optimizersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.$store.state.optimizersEditedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },
        saveEdit() {
            if (this.editedIndex > -1) {
                Object.assign(this.$store.state.optimizersListBool[this.editedIndex], this.$store.state.optimizersEditedItem);
                var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/editOptimizer.php";
            }
            else {
                this.$store.state.optimizersListBool.push(this.$store.state.optimizersEditedItem);
                link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addOptimizer.php";
            }
            this.closeEdit();
            this.$store.state.axios_error = "";
            var data = this.$store.state.optimizersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.optimizersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.optimizersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadOptimizersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.optimizersList = response.data;
                        this.createOptimizersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },
        saveCopy() {
            this.closeCopy();
            var link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/addOptimizer.php";
            this.$store.state.axios_error = "";
            var data = this.$store.state.optimizersEditedItem;
            axios.post(link, data, {
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(response => {
                this.$store.state.optimizersResponse = response;
                this.$store.state.api_status = response.data.api_status;
                this.$store.state.axios_error = "";
                if (response.data.optimizersListSaved) {
                    link = "http://3ur4p2zmartexkth.servebeer.com/domoserverDb/loadOptimizersList.php";
                    axios.get(link).then(response => {
                        this.$store.state.optimizersList = response.data;
                        this.createOptimizersListBool();
                    });
                }
            }).catch((error) => {
                this.$store.state.axios_error = error;
            });
        },

    },
}
</script>
